<template>
  <svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
    viewBox="0 0 200 200" enable-background="new 0 0 200 200" xml:space="preserve">
  <g id="Layer_2_1_">
    <path class="color" fill="#F45B5B" d="M94.979,123.895c-1.279,0.008-2.511-0.496-3.42-1.396l-19.267-19.269c-1.889-1.889-1.889-4.95,0-6.839
      c1.888-1.889,4.95-1.889,6.839,0l15.848,15.896l30.299-30.347c1.889-1.889,4.95-1.889,6.84,0c1.889,1.889,1.889,4.951,0,6.84
      l-33.719,33.719C97.49,123.398,96.259,123.902,94.979,123.895z"/>
    <path class="color" fill="#F45B5B" d="M99.797,162.43c-34.584,0-62.62-28.036-62.62-62.619c0-34.585,28.036-62.62,62.62-62.62
      c34.583,0,62.618,28.035,62.618,62.62C162.415,134.394,134.38,162.43,99.797,162.43z M99.797,46.823
      c-29.265,0-52.986,23.724-52.986,52.987c0,29.262,23.722,52.985,52.986,52.985c29.262,0,52.985-23.724,52.985-52.985
      C152.782,70.547,129.059,46.823,99.797,46.823z"/>
  </g>
  </svg>

</template>

<script>
export default {
  name: 'CheckCircledIcon'
}
</script>
